import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrochip, faCode, faPeopleGroup } from "@fortawesome/free-solid-svg-icons";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Work Experience</h1>
        <VerticalTimeline lineColor="rgba(130, 65, 255, 0.4)">

          {/* Garmin Canada – Wireless Firmware */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2025 – Aug 2025"
            iconStyle={{
              background: "linear-gradient(135deg, #7b2ff7, #6141ff)",
              color: "#fff",
              boxShadow: "0 0 15px rgba(123, 47, 247, 0.5)",
            }}
            icon={<FontAwesomeIcon icon={faMicrochip} />}
          >
            <h3 className="vertical-timeline-element-title">
              Software Engineering Intern – Wireless Firmware
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Garmin Canada · Cochrane, AB
            </h4>
            <ul className="timeline-list">
              <li>Automated firmware compliance tests for Taiwan certification, reducing execution time by 93%</li>
              <li>Diagnosed and fixed a critical BLE bug, increasing concurrent device capacity from 5 to 8</li>
              <li>Built full-stack wireless certification test features from frontend UI to firmware-level validation logic</li>
            </ul>

          </VerticalTimelineElement>

          {/* Garmin Canada – Optical Sensor */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2024 – Dec 2024"
            iconStyle={{
              background: "linear-gradient(135deg, #7b2ff7, #6141ff)",
              color: "#fff",
              boxShadow: "0 0 15px rgba(123, 47, 247, 0.5)",
            }}
            icon={<FontAwesomeIcon icon={faCode} />}
          >
            <h3 className="vertical-timeline-element-title">
              Software Engineering Intern – Optical Sensor
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Garmin Canada · Cochrane, AB
            </h4>
            <ul  className="timeline-list">
              <li>Migrated critical firmware features to a new single-chip platform, reducing build times by 25%</li>
              <li>Automated C mock generation to eliminate build failures</li>
              <li>Built a runtime feature to switch hardware modes without rebuilding, cutting test time by 97%</li>
            </ul>
          </VerticalTimelineElement>

          {/* A&W Canada – Senior Team Member */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2022 – May 2024"
            iconStyle={{
              background: "linear-gradient(135deg, #7b2ff7, #6141ff)",
              color: "#fff",
              boxShadow: "0 0 15px rgba(123, 47, 247, 0.5)",
            }}
            icon={<FontAwesomeIcon icon={faPeopleGroup} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Team Member</h3>
            <h4 className="vertical-timeline-element-subtitle">
              A&W Canada · Calgary, AB
            </h4>
            <ul  className="timeline-list">
              <li>Recognized as Employee of the Month for five consecutive months</li>
              <li>Trained new hires, managed customer escalations, and maintained operational efficiency</li>
            </ul>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
